<template lang="pug">
	.user-profile
		.page-center-content(v-if="user && publisher")
			.caption-area
				.back(v-if="Layout.pageOptions.backPage")
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="Layout.setPage.apply(Layout, Layout.pageOptions.backPage)")
						.icon.fa.fa-angle-double-left
				.caption(:class="{'back-exist': Layout.pageOptions.backPage}") {{user.name}} Profile
				.logo
					img(:src="`/Images/Icons/Publishers/${publisher.codename || publisher.id}.png?v=${publisher['last_activity_time'] || publisher['create_date']}`" :alt="publisher.title")
			.settings-groups-area
				.settings-section
					.settings-group.photo
						.user-photo(:style="{ backgroundImage: `url(${user.photo || 'Images/Screens/Login/default-user-icon.png'})` }")
					.settings-group
						.form-group.user-name
							label Name
							input.form-control(type="text" :value="user.name" @input="saveName($event.target.value)")
					.settings-group
						.form-group
							label Email
							input.form-control(type="text" :value="user.email" disabled)
					.settings-group
						.form-group
							label Photo
							br
							button.btn.btn-secondary(type="button" @click="replacePhoto")
								.icon.fa.fa-upload
								span &nbsp;&nbsp;Upload new photo
					.settings-group(:style="{width: '100px'}")
						.form-group
							label Enabled
							br
							label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(:style="{marginTop: '5px'}")
								input.switch-input.form-check-input(type="checkbox" :checked="user.active" @change="activateUser(user, $event.target.checked)" :disabled="!(User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin'])) || user.isAdmin")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
					.settings-group(:style="{width: '100px', visibility: user.active ? 'hidden' : 'visible'}")
						.form-group
							button.btn.btn-sm.btn-danger(v-if="!user.Tags.deleted" type="button" @click="deleteUser(user)" :style="{marginTop: '7px'}" :disabled="!(User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin'])) || !!user.active")
								.icon.fa.fa-remove
								span Delete
							button.btn.btn-sm.btn-secondary(v-if="user.Tags.deleted" type="button" @click="deleteUserRevert(user)" :style="{marginTop: '7px'}" :disabled="!(User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin'])) || !!user.active")
								.icon.fa.fa-plus
								span Revert
				.settings-section.subcaption(v-if="User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin'])")
					label.no-margin Company
					.description.text-muted
						span The Developer and Manager roles are used just for the information about user and will not affect the Dashboard viewability or functions. The Admin role have possibility to invite, deactivate and delete other users, and change their roles.
					.columns-3
						.column(v-if="User.currentUser.isAdmin")
							.form-group
								label Company
								select.custom-select.form-control(:value="user['publisher_id']" @change="changePublisher($event.target, $event.target.value)" :disabled="!User.currentUser.isAdmin")
									option(v-for="publisher in Publisher.Publishers" v-if="publisher.active || (publisher.id === user['publisher_id'])" :value="publisher.id") {{publisher.title}}
						.column
							.form-group
								label Role
								select.custom-select.form-control(:value="user.role" @change="changeRole($event.target.value)" :disabled="!(User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin']))")
									option(value="developer") Developer
									option(value="manager") Manager
									option(value="publisher-admin") Admin
						.column(v-if="User.currentUser.isAdmin && Layout.isFeatureEnabled('user-switch')")
							.form-group
								label Login as this user
								button.btn.btn-sm.btn-outline-primary(type="button" @click="loginUser(user)")
									.icon.fa.fa-login
									span Login
				.settings-section.subcaption
					label.no-margin Online users
					.description.text-muted
						span Enable this feature to see your company online users
					.columns-5
						.column
							.form-group
								label Show online users
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" v-model="features['online-users']" v-on:change="User.toggleFeature(user.id, 'online-users', features['online-users'])")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="User.currentUser.isAdmin && features['online-users']")
							.form-group
								label Over publisher list
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="features['online-users-publisher-list']" v-on:change="User.toggleFeature(user.id, 'online-users-publisher-list', features['online-users-publisher-list'])")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="User.currentUser.isAdmin && features['online-users']")
							.form-group
								label Publisher list colors
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="features['online-users-publisher-color']" v-on:change="User.toggleFeature(user.id, 'online-users-publisher-color', features['online-users-publisher-color'])")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="features['online-users']")
							.form-group
								label Over project list
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="features['online-users-project-plane']" v-on:change="User.toggleFeature(user.id, 'online-users-project-plane', features['online-users-project-plane'])")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="features['online-users']")
							.form-group
								label Over version list
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="features['online-users-version-plane']" v-on:change="User.toggleFeature(user.id, 'online-users-version-plane', features['online-users-version-plane'])")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
				.settings-section.subcaption(v-if="user.id === User.currentUser.id || User.currentUser.Tags['publisher-admin']" style="position: relative; padding: 0;")
					.detailed-log-button
						button.btn.btn-primary(@click="Layout.setPage('user-actions-log', {userId: user.id, backPage: ['user-profile', {userId: user.id}]})")
							.icon.fa.fa-list-alt
							| &nbsp;&nbsp;Detailed log
					div(style="padding: 0 1rem")
						label.no-margin Last user actions log
						.description.text-muted
							span Only important actions are shown here. To view all actions, click on "Detailed log".
					.actions-data-table
						DataTable(name="user-profile-log" entity="monitoring_actions" :fields="fields" :filters="filters" :buttons="buttons" key-field="id" :sort="['date', 'desc']" :update-on="['Layout Page Showed:user-profile']" :update-if="() => Layout.page === 'user-profile'" :entries-count="'25'" :header="false" :footer="false")

</template>

<script>
	import Screen 				from './../../mixins/screen'

	import { Layout } 			from './../../services/Layout'
	import { Publisher } 		from './../../services/Publisher'
	import { User } 			from './../../services/User'

	import DataTable			from './../../components/Templates/DataTable'

	import SetupSettings 		from "./../../settings/settings.json";

	export default {
		name: "UserProfile",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Publisher Changed", "Current User Changed", "Layout Page Showed:user-profile", "Current User Feature Changed",
			"User Changed"]
		},
		components: {
			DataTable
		},
		data() {

			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: false,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '70px'
				},
				{
					fieldName: 'date',
					title: 'Date',
					type: 'date',
					class: 'date-only',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '100px'
				},
				{
					fieldName: 'type',
					title: 'Log type',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '150px'
				},
				{
					fieldName: 'title',
					title: 'Title',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '250px'
				},
				{
					fieldName: 'description',
					title: 'Description',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false
				}
			];

			this.filters = [];

			this.buttons = [];

			this.user = null;
			this.publisher = null;

			this.features = {};

			return {
				showed: true,
				userId: null,
				onlineUsers: true
			};

		},
		methods: {
			collectData(reason) {

				if (Layout.page === 'user-profile' && Layout.pageOptions?.userId) {

					this.userId = Layout.pageOptions.userId;

				} else if (User.currentUser) {

					this.userId = User.currentUser.id;

				} else {

					this.userId = null;

				}

				if (reason === 'Layout Page Showed:user-profile') {

					Server.sendToServer({
						GetUserProfile: this.userId
					});

				}

				this.user = User.Users[this.userId];

				this.publisher = Publisher.Publishers[this.user?.['publisher_id']];

				if (this.user) {

					this.filters.length = 0;

					this.filters.push({
						title: 'User',
						field: 'user_id',
						type: 'equal',
						value: this.user.id,
						display: false
					});

					this.filters.push({
						title: 'Type',
						field: 'type',
						type: 'not:in',
						value: ['navigation', 'availability'],
						display: false
					});

				}

				this.features = _.clone(this.user?.options?.['features'] || {});

				this.onlineUsers = !!this.features['online-users'];

			},
			saveName(name) {

				Server.sendWithTimeout({
					UpdateUserName: {
						userId: this.user.id,
						name
					}
				});

			},
			replacePhoto() {

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "image/png, image/jpeg";

				input.addEventListener('change', e => {

					let file = e.target.files[0];

					let formData = new FormData();

					formData.append("userId", this.userId);
					formData.append("file", file);

					let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/user/uploadPhoto';
					if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/user/uploadPhoto';

					let xhr = new XMLHttpRequest();

					xhr.withCredentials = true;

					xhr.open("POST", url);

					xhr.upload.onprogress = function(e) {
						if (e.lengthComputable) {
							this.uploadProgress = e.loaded / e.total;
						}
					};

					xhr.upload.onloadstart = function(e) {
						this.isUploading = true;
					};

					xhr.upload.onloadend = function(e) {
						this.isUploading = false;
					};

					xhr.send(formData);

					document.body.removeChild(input);

				});

				input.click();

			},
			saveOption(optionsName, newData) {

				Server.sendWithTimeout({
					UpdateUserOptions: {
						userId: this.user.id,
						[optionsName]: newData
					}
				}, null, 1000);

			},
			activateUser(user, active) {

				Server.sendToSocket({
					SetUserStatus: {
						userId: user.id,
						active: active
					}
				})

			},
			deleteUser(user) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete user',
					message: `Are you sure you want to delete user "${user.name}"?<br>He will not be visible in any lists any more.`,
					confirmButtonText: '&nbsp;&nbsp;Delete user',
					confirmButtonIcon: 'fa-remove',
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteUser: this.user.id
						});
					}
				}])

			},
			deleteUserRevert(user) {

				Server.sendToSocket({
					DeleteUserRevert: this.user.id
				});

			},
			changePublisher(el, publisherId) {

				Broadcast.call('Show Confirm', [{
					caption: 'Change company',
					message: `Are you sure you want to change company for user "${this.user.name}" to "${Publisher.Publishers[publisherId]?.title}"?`,
					confirmButtonText: '&nbsp;&nbsp;Change company',
					confirmButtonIcon: 'fa-exchange',
					confirmCallback: () => {

						Server.sendToSocket({
							ChangeUserPublisher: {
								userId: this.user.id,
								publisherId: parseInt(publisherId)
							}
						});

					},
					cancelCallback: () => {
						el.value = this.user['publisher_id']
					}
				}]);

			},
			changeRole(role) {

				Server.sendToSocket({
					ChangeUserRole: {
						userId: this.user.id,
						role: role
					}
				});

			},
			loginUser() {

				Server.sendToSocket({
					LoginUser: {
						userId: this.user.id
					}
				});

			}
		}
	}
</script>

<style lang="sass" scoped>

	.user-profile
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1000px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: start
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

				.back
					display: flex
					align-items: center
					justify-content: center
					padding: 0.2rem 1rem

					button
						width: 30px
						height: 30px

				.caption
					padding: 1rem

				.caption.back-exist
					padding: 1rem 0

				.logo
					display: flex
					margin-left: auto
					padding: 10px

					img
						display: flex
						height: 33px
						margin: 0 10px
						align-items: center
						color: #fff
						padding-left: 10px
						text-transform: uppercase

			.settings-groups-area
				display: flex
				flex-direction: column
				flex-wrap: nowrap

				.settings-section
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					margin: 1rem
					margin-bottom: 0
					border-bottom: 1px solid rgba(0,0,0,0.2)
					padding-bottom: 1rem

					.settings-group
						padding: 0 1rem
						width: 50%

						.form-group
							margin-bottom: 0

						.form-group.user-name
							border-left: 1px solid rgba(0, 0, 0, 0.2)
							padding-left: 20px

					.settings-group.photo
						width: 66px
						padding: 0

				.settings-section.subcaption
					flex-direction: column
					flex-wrap: nowrap
					padding: 0 1rem
					padding-bottom: 1rem

					> label
						margin-bottom: 20px

					> label.no-margin
						margin-bottom: 0

					.description
						margin-bottom: 20px

				.columns-3
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					width: 100%

					.column
						display: flex
						flex-direction: column
						width: 33%
						padding-right: 1rem

						.form-group
							display: flex
							flex-direction: column
							align-items: start
							justify-content: start

						.form-group.inline
							flex-direction: row
							align-items: center

						.form-group.no-margin
							margin-bottom: 0

				.columns-5
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					width: 100%

					.column
						display: flex
						flex-direction: column
						width: 20%
						padding-right: 1rem

						.form-group
							display: flex
							flex-direction: column
							align-items: start
							justify-content: start

				.user-photo
					width: 64px
					height: 64px
					border-radius: 32px
					background: center/auto 100% no-repeat
					margin-right: 15px

				.detailed-log-button
					position: absolute
					right: 10px
					top: 3px

		label
			margin-bottom: 0.5rem

		input[type="text"]
			width: 100%
			height: calc(1.5em + 0.75rem + 2px)
			padding: 0.375rem 0.75rem
			font-size: 0.875rem
			font-weight: 400
			line-height: 1.5
			color: rgba(255, 255, 255, 0.87)
			background-color: rgba(255, 255, 255, 0.05)
			border: 1px solid rgba(255, 255, 255, 0.09)
			border-radius: 0.25rem
			transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out

		.multi-select-checkbox
			margin-bottom: 10px

			label
				margin-bottom: 0
				cursor: pointer

				.form-check-input
					top: -1px

				input
					cursor: pointer

		.custom-select
			width: auto

	@media screen and (max-width: 600px)

		.publisher-settings

			.page-center-content

				.settings-groups-area

					.settings-group
						width: 100%

</style>

